import { cn } from '../../lib/format.js';

/**
 * Loading placeholders. Sized to the content they stand in for, so nothing
 * shifts when the real thing arrives — a skeleton that is the wrong height
 * causes the layout shift it was meant to prevent.
 */
export const Skeleton = ({ className, ...props }) => (
  <div
    aria-hidden="true"
    className={cn('bg-sand/60 motion-safe:animate-pulse', className)}
    {...props}
  />
);

export const SkeletonText = ({ lines = 3, className }) => (
  <div className={cn('space-y-2', className)} aria-hidden="true">
    {Array.from({ length: lines }, (_, index) => (
      <Skeleton
        key={index}
        className="h-3.5"
        style={{ width: index === lines - 1 ? '62%' : '100%' }}
      />
    ))}
  </div>
);

/** The product card's exact footprint, so a grid does not reflow as it fills. */
export const SkeletonCard = () => (
  <div className="flex h-full flex-col items-center border border-mist bg-surface p-3" aria-hidden="true">
    <Skeleton className="aspect-3/4 w-full" />
    <div className="mt-3 flex gap-1.5">
      <Skeleton className="h-6 w-11" />
      <Skeleton className="h-6 w-11" />
    </div>
    <Skeleton className="mt-3 h-3.5 w-11/12" />
    <Skeleton className="mt-1.5 h-3.5 w-2/3" />
    <Skeleton className="mt-2.5 h-3 w-20" />
    <Skeleton className="mt-3 h-4 w-24" />
    <Skeleton className="mt-3 h-8 w-28" />
  </div>
);

export default Skeleton;
